module.exports = __webpack_public_path__ + "static/img/Join.en.ac863a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Landing/Join.en.png
// module id = 565
// module chunks = 4